/* @flow */
import apiRequest from 'lib/apiRequest';
import ExternalAccountResource from 'entities/ExternalAccountResource';
import Collection from 'lib/Collection';

export default class ExternalAccountResources extends Collection {
  initialize() {
    this.model = ExternalAccountResource;
  }

  static load() {
    return apiRequest('/payments/payment_destinations', 'GET')
      .then(accounts => ExternalAccountResources.fromJSON(accounts));
  }
}



// WEBPACK FOOTER //
// ./src/collections/ExternalAccountResources.js